"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BAGGAGE_HEADER_NAME", {
  enumerable: true,
  get: function () {
    return _baggage.BAGGAGE_HEADER_NAME;
  }
});
Object.defineProperty(exports, "BaseClient", {
  enumerable: true,
  get: function () {
    return _baseclient.BaseClient;
  }
});
Object.defineProperty(exports, "BrowserMetricsAggregator", {
  enumerable: true,
  get: function () {
    return _browserAggregator.BrowserMetricsAggregator;
  }
});
Object.defineProperty(exports, "CONSOLE_LEVELS", {
  enumerable: true,
  get: function () {
    return _logger.CONSOLE_LEVELS;
  }
});
Object.defineProperty(exports, "DEFAULT_ENVIRONMENT", {
  enumerable: true,
  get: function () {
    return _constants.DEFAULT_ENVIRONMENT;
  }
});
Object.defineProperty(exports, "DEFAULT_RETRY_AFTER", {
  enumerable: true,
  get: function () {
    return _ratelimit.DEFAULT_RETRY_AFTER;
  }
});
Object.defineProperty(exports, "DEFAULT_USER_INCLUDES", {
  enumerable: true,
  get: function () {
    return _requestdata2.DEFAULT_USER_INCLUDES;
  }
});
Object.defineProperty(exports, "GLOBAL_OBJ", {
  enumerable: true,
  get: function () {
    return _worldwide.GLOBAL_OBJ;
  }
});
Object.defineProperty(exports, "LRUMap", {
  enumerable: true,
  get: function () {
    return _lru.LRUMap;
  }
});
Object.defineProperty(exports, "MAX_BAGGAGE_STRING_LENGTH", {
  enumerable: true,
  get: function () {
    return _baggage.MAX_BAGGAGE_STRING_LENGTH;
  }
});
Object.defineProperty(exports, "SDK_VERSION", {
  enumerable: true,
  get: function () {
    return _version.SDK_VERSION;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_CACHE_HIT", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_CACHE_HIT;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_CACHE_KEY", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_CACHE_KEY;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_PROFILE_ID;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_OP;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
  }
});
Object.defineProperty(exports, "SEMANTIC_ATTRIBUTE_URL_FULL", {
  enumerable: true,
  get: function () {
    return _semanticAttributes.SEMANTIC_ATTRIBUTE_URL_FULL;
  }
});
Object.defineProperty(exports, "SENTRY_BAGGAGE_KEY_PREFIX", {
  enumerable: true,
  get: function () {
    return _baggage.SENTRY_BAGGAGE_KEY_PREFIX;
  }
});
Object.defineProperty(exports, "SENTRY_BAGGAGE_KEY_PREFIX_REGEX", {
  enumerable: true,
  get: function () {
    return _baggage.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
  }
});
Object.defineProperty(exports, "SPAN_STATUS_ERROR", {
  enumerable: true,
  get: function () {
    return _spanstatus.SPAN_STATUS_ERROR;
  }
});
Object.defineProperty(exports, "SPAN_STATUS_OK", {
  enumerable: true,
  get: function () {
    return _spanstatus.SPAN_STATUS_OK;
  }
});
Object.defineProperty(exports, "SPAN_STATUS_UNSET", {
  enumerable: true,
  get: function () {
    return _spanstatus.SPAN_STATUS_UNSET;
  }
});
Object.defineProperty(exports, "Scope", {
  enumerable: true,
  get: function () {
    return _scope.Scope;
  }
});
Object.defineProperty(exports, "SentryError", {
  enumerable: true,
  get: function () {
    return _error.SentryError;
  }
});
Object.defineProperty(exports, "SentryNonRecordingSpan", {
  enumerable: true,
  get: function () {
    return _sentryNonRecordingSpan.SentryNonRecordingSpan;
  }
});
Object.defineProperty(exports, "SentrySpan", {
  enumerable: true,
  get: function () {
    return _sentrySpan.SentrySpan;
  }
});
Object.defineProperty(exports, "ServerRuntimeClient", {
  enumerable: true,
  get: function () {
    return _serverRuntimeClient.ServerRuntimeClient;
  }
});
Object.defineProperty(exports, "SessionFlusher", {
  enumerable: true,
  get: function () {
    return _sessionflusher.SessionFlusher;
  }
});
Object.defineProperty(exports, "SyncPromise", {
  enumerable: true,
  get: function () {
    return _syncpromise.SyncPromise;
  }
});
Object.defineProperty(exports, "TRACEPARENT_REGEXP", {
  enumerable: true,
  get: function () {
    return _tracing.TRACEPARENT_REGEXP;
  }
});
Object.defineProperty(exports, "TRACING_DEFAULTS", {
  enumerable: true,
  get: function () {
    return _idleSpan.TRACING_DEFAULTS;
  }
});
Object.defineProperty(exports, "UNKNOWN_FUNCTION", {
  enumerable: true,
  get: function () {
    return _stacktrace.UNKNOWN_FUNCTION;
  }
});
Object.defineProperty(exports, "_asyncNullishCoalesce", {
  enumerable: true,
  get: function () {
    return _asyncNullishCoalesce._asyncNullishCoalesce;
  }
});
Object.defineProperty(exports, "_asyncOptionalChain", {
  enumerable: true,
  get: function () {
    return _asyncOptionalChain._asyncOptionalChain;
  }
});
Object.defineProperty(exports, "_asyncOptionalChainDelete", {
  enumerable: true,
  get: function () {
    return _asyncOptionalChainDelete._asyncOptionalChainDelete;
  }
});
Object.defineProperty(exports, "_browserPerformanceTimeOriginMode", {
  enumerable: true,
  get: function () {
    return _time._browserPerformanceTimeOriginMode;
  }
});
Object.defineProperty(exports, "_nullishCoalesce", {
  enumerable: true,
  get: function () {
    return _nullishCoalesce._nullishCoalesce;
  }
});
Object.defineProperty(exports, "_optionalChain", {
  enumerable: true,
  get: function () {
    return _optionalChain._optionalChain;
  }
});
Object.defineProperty(exports, "_optionalChainDelete", {
  enumerable: true,
  get: function () {
    return _optionalChainDelete._optionalChainDelete;
  }
});
Object.defineProperty(exports, "addBreadcrumb", {
  enumerable: true,
  get: function () {
    return _breadcrumbs.addBreadcrumb;
  }
});
Object.defineProperty(exports, "addChildSpanToSpan", {
  enumerable: true,
  get: function () {
    return _spanUtils.addChildSpanToSpan;
  }
});
Object.defineProperty(exports, "addConsoleInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _console.addConsoleInstrumentationHandler;
  }
});
Object.defineProperty(exports, "addContextToFrame", {
  enumerable: true,
  get: function () {
    return _misc.addContextToFrame;
  }
});
Object.defineProperty(exports, "addEventProcessor", {
  enumerable: true,
  get: function () {
    return _exports.addEventProcessor;
  }
});
Object.defineProperty(exports, "addExceptionMechanism", {
  enumerable: true,
  get: function () {
    return _misc.addExceptionMechanism;
  }
});
Object.defineProperty(exports, "addExceptionTypeValue", {
  enumerable: true,
  get: function () {
    return _misc.addExceptionTypeValue;
  }
});
Object.defineProperty(exports, "addFetchEndInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _fetch2.addFetchEndInstrumentationHandler;
  }
});
Object.defineProperty(exports, "addFetchInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _fetch2.addFetchInstrumentationHandler;
  }
});
Object.defineProperty(exports, "addGlobalErrorInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _globalError.addGlobalErrorInstrumentationHandler;
  }
});
Object.defineProperty(exports, "addGlobalUnhandledRejectionInstrumentationHandler", {
  enumerable: true,
  get: function () {
    return _globalUnhandledRejection.addGlobalUnhandledRejectionInstrumentationHandler;
  }
});
Object.defineProperty(exports, "addHandler", {
  enumerable: true,
  get: function () {
    return _handlers.addHandler;
  }
});
Object.defineProperty(exports, "addIntegration", {
  enumerable: true,
  get: function () {
    return _integration.addIntegration;
  }
});
Object.defineProperty(exports, "addItemToEnvelope", {
  enumerable: true,
  get: function () {
    return _envelope2.addItemToEnvelope;
  }
});
Object.defineProperty(exports, "addNonEnumerableProperty", {
  enumerable: true,
  get: function () {
    return _object.addNonEnumerableProperty;
  }
});
Object.defineProperty(exports, "addNormalizedRequestDataToEvent", {
  enumerable: true,
  get: function () {
    return _requestdata2.addNormalizedRequestDataToEvent;
  }
});
Object.defineProperty(exports, "addRequestDataToEvent", {
  enumerable: true,
  get: function () {
    return _requestdata2.addRequestDataToEvent;
  }
});
Object.defineProperty(exports, "addTracingExtensions", {
  enumerable: true,
  get: function () {
    return _hubextensions.addTracingExtensions;
  }
});
Object.defineProperty(exports, "addTracingHeadersToFetchRequest", {
  enumerable: true,
  get: function () {
    return _fetch.addTracingHeadersToFetchRequest;
  }
});
Object.defineProperty(exports, "applyAggregateErrorsToEvent", {
  enumerable: true,
  get: function () {
    return _aggregateErrors.applyAggregateErrorsToEvent;
  }
});
Object.defineProperty(exports, "applyScopeDataToEvent", {
  enumerable: true,
  get: function () {
    return _applyScopeDataToEvent.applyScopeDataToEvent;
  }
});
Object.defineProperty(exports, "applySdkMetadata", {
  enumerable: true,
  get: function () {
    return _sdkMetadata.applySdkMetadata;
  }
});
Object.defineProperty(exports, "arrayify", {
  enumerable: true,
  get: function () {
    return _misc.arrayify;
  }
});
Object.defineProperty(exports, "baggageHeaderToDynamicSamplingContext", {
  enumerable: true,
  get: function () {
    return _baggage.baggageHeaderToDynamicSamplingContext;
  }
});
Object.defineProperty(exports, "basename", {
  enumerable: true,
  get: function () {
    return _path.basename;
  }
});
Object.defineProperty(exports, "browserPerformanceTimeOrigin", {
  enumerable: true,
  get: function () {
    return _time.browserPerformanceTimeOrigin;
  }
});
Object.defineProperty(exports, "callFrameToStackFrame", {
  enumerable: true,
  get: function () {
    return _anr.callFrameToStackFrame;
  }
});
Object.defineProperty(exports, "captureCheckIn", {
  enumerable: true,
  get: function () {
    return _exports.captureCheckIn;
  }
});
Object.defineProperty(exports, "captureConsoleIntegration", {
  enumerable: true,
  get: function () {
    return _captureconsole.captureConsoleIntegration;
  }
});
Object.defineProperty(exports, "captureEvent", {
  enumerable: true,
  get: function () {
    return _exports.captureEvent;
  }
});
Object.defineProperty(exports, "captureException", {
  enumerable: true,
  get: function () {
    return _exports.captureException;
  }
});
Object.defineProperty(exports, "captureFeedback", {
  enumerable: true,
  get: function () {
    return _feedback.captureFeedback;
  }
});
Object.defineProperty(exports, "captureMessage", {
  enumerable: true,
  get: function () {
    return _exports.captureMessage;
  }
});
Object.defineProperty(exports, "captureSession", {
  enumerable: true,
  get: function () {
    return _exports.captureSession;
  }
});
Object.defineProperty(exports, "checkOrSetAlreadyCaught", {
  enumerable: true,
  get: function () {
    return _misc.checkOrSetAlreadyCaught;
  }
});
Object.defineProperty(exports, "close", {
  enumerable: true,
  get: function () {
    return _exports.close;
  }
});
Object.defineProperty(exports, "closeSession", {
  enumerable: true,
  get: function () {
    return _session.closeSession;
  }
});
Object.defineProperty(exports, "consoleSandbox", {
  enumerable: true,
  get: function () {
    return _logger.consoleSandbox;
  }
});
Object.defineProperty(exports, "continueTrace", {
  enumerable: true,
  get: function () {
    return _trace.continueTrace;
  }
});
Object.defineProperty(exports, "convertToPlainObject", {
  enumerable: true,
  get: function () {
    return _object.convertToPlainObject;
  }
});
Object.defineProperty(exports, "createAttachmentEnvelopeItem", {
  enumerable: true,
  get: function () {
    return _envelope2.createAttachmentEnvelopeItem;
  }
});
Object.defineProperty(exports, "createCheckInEnvelope", {
  enumerable: true,
  get: function () {
    return _checkin.createCheckInEnvelope;
  }
});
Object.defineProperty(exports, "createClientReportEnvelope", {
  enumerable: true,
  get: function () {
    return _clientreport.createClientReportEnvelope;
  }
});
Object.defineProperty(exports, "createEnvelope", {
  enumerable: true,
  get: function () {
    return _envelope2.createEnvelope;
  }
});
Object.defineProperty(exports, "createEventEnvelope", {
  enumerable: true,
  get: function () {
    return _envelope.createEventEnvelope;
  }
});
Object.defineProperty(exports, "createEventEnvelopeHeaders", {
  enumerable: true,
  get: function () {
    return _envelope2.createEventEnvelopeHeaders;
  }
});
Object.defineProperty(exports, "createSessionEnvelope", {
  enumerable: true,
  get: function () {
    return _envelope.createSessionEnvelope;
  }
});
Object.defineProperty(exports, "createSpanEnvelope", {
  enumerable: true,
  get: function () {
    return _envelope.createSpanEnvelope;
  }
});
Object.defineProperty(exports, "createSpanEnvelopeItem", {
  enumerable: true,
  get: function () {
    return _envelope2.createSpanEnvelopeItem;
  }
});
Object.defineProperty(exports, "createStackParser", {
  enumerable: true,
  get: function () {
    return _stacktrace.createStackParser;
  }
});
Object.defineProperty(exports, "createTransport", {
  enumerable: true,
  get: function () {
    return _base.createTransport;
  }
});
Object.defineProperty(exports, "dateTimestampInSeconds", {
  enumerable: true,
  get: function () {
    return _time.dateTimestampInSeconds;
  }
});
Object.defineProperty(exports, "debugIntegration", {
  enumerable: true,
  get: function () {
    return _debug.debugIntegration;
  }
});
Object.defineProperty(exports, "dedupeIntegration", {
  enumerable: true,
  get: function () {
    return _dedupe.dedupeIntegration;
  }
});
Object.defineProperty(exports, "defineIntegration", {
  enumerable: true,
  get: function () {
    return _integration.defineIntegration;
  }
});
Object.defineProperty(exports, "dirname", {
  enumerable: true,
  get: function () {
    return _path.dirname;
  }
});
Object.defineProperty(exports, "disabledUntil", {
  enumerable: true,
  get: function () {
    return _ratelimit.disabledUntil;
  }
});
Object.defineProperty(exports, "dropUndefinedKeys", {
  enumerable: true,
  get: function () {
    return _object.dropUndefinedKeys;
  }
});
Object.defineProperty(exports, "dsnFromString", {
  enumerable: true,
  get: function () {
    return _dsn.dsnFromString;
  }
});
Object.defineProperty(exports, "dsnToString", {
  enumerable: true,
  get: function () {
    return _dsn.dsnToString;
  }
});
Object.defineProperty(exports, "dynamicRequire", {
  enumerable: true,
  get: function () {
    return _node.dynamicRequire;
  }
});
Object.defineProperty(exports, "dynamicSamplingContextToSentryBaggageHeader", {
  enumerable: true,
  get: function () {
    return _baggage.dynamicSamplingContextToSentryBaggageHeader;
  }
});
Object.defineProperty(exports, "endSession", {
  enumerable: true,
  get: function () {
    return _exports.endSession;
  }
});
Object.defineProperty(exports, "envelopeContainsItemType", {
  enumerable: true,
  get: function () {
    return _envelope2.envelopeContainsItemType;
  }
});
Object.defineProperty(exports, "envelopeItemTypeToDataCategory", {
  enumerable: true,
  get: function () {
    return _envelope2.envelopeItemTypeToDataCategory;
  }
});
Object.defineProperty(exports, "escapeStringForRegex", {
  enumerable: true,
  get: function () {
    return _escapeStringForRegex.escapeStringForRegex;
  }
});
Object.defineProperty(exports, "eventFromMessage", {
  enumerable: true,
  get: function () {
    return _eventbuilder.eventFromMessage;
  }
});
Object.defineProperty(exports, "eventFromUnknownInput", {
  enumerable: true,
  get: function () {
    return _eventbuilder.eventFromUnknownInput;
  }
});
Object.defineProperty(exports, "exceptionFromError", {
  enumerable: true,
  get: function () {
    return _eventbuilder.exceptionFromError;
  }
});
Object.defineProperty(exports, "extraErrorDataIntegration", {
  enumerable: true,
  get: function () {
    return _extraerrordata.extraErrorDataIntegration;
  }
});
Object.defineProperty(exports, "extractExceptionKeysForMessage", {
  enumerable: true,
  get: function () {
    return _object.extractExceptionKeysForMessage;
  }
});
Object.defineProperty(exports, "extractPathForTransaction", {
  enumerable: true,
  get: function () {
    return _requestdata2.extractPathForTransaction;
  }
});
Object.defineProperty(exports, "extractQueryParamsFromUrl", {
  enumerable: true,
  get: function () {
    return _requestdata2.extractQueryParamsFromUrl;
  }
});
Object.defineProperty(exports, "extractRequestData", {
  enumerable: true,
  get: function () {
    return _requestdata2.extractRequestData;
  }
});
Object.defineProperty(exports, "extractTraceparentData", {
  enumerable: true,
  get: function () {
    return _tracing.extractTraceparentData;
  }
});
Object.defineProperty(exports, "filenameIsInApp", {
  enumerable: true,
  get: function () {
    return _nodeStackTrace.filenameIsInApp;
  }
});
Object.defineProperty(exports, "fill", {
  enumerable: true,
  get: function () {
    return _object.fill;
  }
});
Object.defineProperty(exports, "flatten", {
  enumerable: true,
  get: function () {
    return _array.flatten;
  }
});
Object.defineProperty(exports, "flush", {
  enumerable: true,
  get: function () {
    return _exports.flush;
  }
});
Object.defineProperty(exports, "forEachEnvelopeItem", {
  enumerable: true,
  get: function () {
    return _envelope2.forEachEnvelopeItem;
  }
});
Object.defineProperty(exports, "functionToStringIntegration", {
  enumerable: true,
  get: function () {
    return _functiontostring.functionToStringIntegration;
  }
});
Object.defineProperty(exports, "generatePropagationContext", {
  enumerable: true,
  get: function () {
    return _propagationContext.generatePropagationContext;
  }
});
Object.defineProperty(exports, "generateSentryTraceHeader", {
  enumerable: true,
  get: function () {
    return _tracing.generateSentryTraceHeader;
  }
});
Object.defineProperty(exports, "generateSpanId", {
  enumerable: true,
  get: function () {
    return _propagationContext.generateSpanId;
  }
});
Object.defineProperty(exports, "generateTraceId", {
  enumerable: true,
  get: function () {
    return _propagationContext.generateTraceId;
  }
});
Object.defineProperty(exports, "getActiveSpan", {
  enumerable: true,
  get: function () {
    return _spanUtils.getActiveSpan;
  }
});
Object.defineProperty(exports, "getBreadcrumbLogLevelFromHttpStatusCode", {
  enumerable: true,
  get: function () {
    return _breadcrumbLogLevel.getBreadcrumbLogLevelFromHttpStatusCode;
  }
});
Object.defineProperty(exports, "getCapturedScopesOnSpan", {
  enumerable: true,
  get: function () {
    return _utils.getCapturedScopesOnSpan;
  }
});
Object.defineProperty(exports, "getClient", {
  enumerable: true,
  get: function () {
    return _currentScopes.getClient;
  }
});
Object.defineProperty(exports, "getComponentName", {
  enumerable: true,
  get: function () {
    return _browser.getComponentName;
  }
});
Object.defineProperty(exports, "getCurrentHub", {
  enumerable: true,
  get: function () {
    return _getCurrentHubShim.getCurrentHub;
  }
});
Object.defineProperty(exports, "getCurrentHubShim", {
  enumerable: true,
  get: function () {
    return _getCurrentHubShim.getCurrentHubShim;
  }
});
Object.defineProperty(exports, "getCurrentScope", {
  enumerable: true,
  get: function () {
    return _currentScopes.getCurrentScope;
  }
});
Object.defineProperty(exports, "getDebugImagesForResources", {
  enumerable: true,
  get: function () {
    return _debugIds.getDebugImagesForResources;
  }
});
Object.defineProperty(exports, "getDefaultCurrentScope", {
  enumerable: true,
  get: function () {
    return _defaultScopes.getDefaultCurrentScope;
  }
});
Object.defineProperty(exports, "getDefaultIsolationScope", {
  enumerable: true,
  get: function () {
    return _defaultScopes.getDefaultIsolationScope;
  }
});
Object.defineProperty(exports, "getDomElement", {
  enumerable: true,
  get: function () {
    return _browser.getDomElement;
  }
});
Object.defineProperty(exports, "getDynamicSamplingContextFromClient", {
  enumerable: true,
  get: function () {
    return _dynamicSamplingContext.getDynamicSamplingContextFromClient;
  }
});
Object.defineProperty(exports, "getDynamicSamplingContextFromScope", {
  enumerable: true,
  get: function () {
    return _dynamicSamplingContext.getDynamicSamplingContextFromScope;
  }
});
Object.defineProperty(exports, "getDynamicSamplingContextFromSpan", {
  enumerable: true,
  get: function () {
    return _dynamicSamplingContext.getDynamicSamplingContextFromSpan;
  }
});
Object.defineProperty(exports, "getEnvelopeEndpointWithUrlEncodedAuth", {
  enumerable: true,
  get: function () {
    return _api.getEnvelopeEndpointWithUrlEncodedAuth;
  }
});
Object.defineProperty(exports, "getEventDescription", {
  enumerable: true,
  get: function () {
    return _misc.getEventDescription;
  }
});
Object.defineProperty(exports, "getFilenameToDebugIdMap", {
  enumerable: true,
  get: function () {
    return _debugIds.getFilenameToDebugIdMap;
  }
});
Object.defineProperty(exports, "getFramesFromEvent", {
  enumerable: true,
  get: function () {
    return _stacktrace.getFramesFromEvent;
  }
});
Object.defineProperty(exports, "getFunctionName", {
  enumerable: true,
  get: function () {
    return _stacktrace.getFunctionName;
  }
});
Object.defineProperty(exports, "getGlobalScope", {
  enumerable: true,
  get: function () {
    return _currentScopes.getGlobalScope;
  }
});
Object.defineProperty(exports, "getGlobalSingleton", {
  enumerable: true,
  get: function () {
    return _worldwide.getGlobalSingleton;
  }
});
Object.defineProperty(exports, "getIntegrationsToSetup", {
  enumerable: true,
  get: function () {
    return _integration.getIntegrationsToSetup;
  }
});
Object.defineProperty(exports, "getIsolationScope", {
  enumerable: true,
  get: function () {
    return _currentScopes.getIsolationScope;
  }
});
Object.defineProperty(exports, "getLocationHref", {
  enumerable: true,
  get: function () {
    return _browser.getLocationHref;
  }
});
Object.defineProperty(exports, "getMainCarrier", {
  enumerable: true,
  get: function () {
    return _carrier.getMainCarrier;
  }
});
Object.defineProperty(exports, "getMetricSummaryJsonForSpan", {
  enumerable: true,
  get: function () {
    return _metricSummary.getMetricSummaryJsonForSpan;
  }
});
Object.defineProperty(exports, "getNumberOfUrlSegments", {
  enumerable: true,
  get: function () {
    return _url.getNumberOfUrlSegments;
  }
});
Object.defineProperty(exports, "getOriginalFunction", {
  enumerable: true,
  get: function () {
    return _object.getOriginalFunction;
  }
});
Object.defineProperty(exports, "getReportDialogEndpoint", {
  enumerable: true,
  get: function () {
    return _api.getReportDialogEndpoint;
  }
});
Object.defineProperty(exports, "getRootSpan", {
  enumerable: true,
  get: function () {
    return _spanUtils.getRootSpan;
  }
});
Object.defineProperty(exports, "getSDKSource", {
  enumerable: true,
  get: function () {
    return _env.getSDKSource;
  }
});
Object.defineProperty(exports, "getSanitizedUrlString", {
  enumerable: true,
  get: function () {
    return _url.getSanitizedUrlString;
  }
});
Object.defineProperty(exports, "getSdkMetadataForEnvelopeHeader", {
  enumerable: true,
  get: function () {
    return _envelope2.getSdkMetadataForEnvelopeHeader;
  }
});
Object.defineProperty(exports, "getSpanDescendants", {
  enumerable: true,
  get: function () {
    return _spanUtils.getSpanDescendants;
  }
});
Object.defineProperty(exports, "getSpanStatusFromHttpCode", {
  enumerable: true,
  get: function () {
    return _spanstatus.getSpanStatusFromHttpCode;
  }
});
Object.defineProperty(exports, "getStatusMessage", {
  enumerable: true,
  get: function () {
    return _spanUtils.getStatusMessage;
  }
});
Object.defineProperty(exports, "getTraceContextFromScope", {
  enumerable: true,
  get: function () {
    return _currentScopes.getTraceContextFromScope;
  }
});
Object.defineProperty(exports, "getTraceData", {
  enumerable: true,
  get: function () {
    return _traceData.getTraceData;
  }
});
Object.defineProperty(exports, "getTraceMetaTags", {
  enumerable: true,
  get: function () {
    return _meta.getTraceMetaTags;
  }
});
Object.defineProperty(exports, "handleCallbackErrors", {
  enumerable: true,
  get: function () {
    return _handleCallbackErrors.handleCallbackErrors;
  }
});
Object.defineProperty(exports, "hasTracingEnabled", {
  enumerable: true,
  get: function () {
    return _hasTracingEnabled.hasTracingEnabled;
  }
});
Object.defineProperty(exports, "headersToDict", {
  enumerable: true,
  get: function () {
    return _requestdata2.headersToDict;
  }
});
Object.defineProperty(exports, "htmlTreeAsString", {
  enumerable: true,
  get: function () {
    return _browser.htmlTreeAsString;
  }
});
Object.defineProperty(exports, "httpRequestToRequestData", {
  enumerable: true,
  get: function () {
    return _requestdata2.httpRequestToRequestData;
  }
});
Object.defineProperty(exports, "inboundFiltersIntegration", {
  enumerable: true,
  get: function () {
    return _inboundfilters.inboundFiltersIntegration;
  }
});
Object.defineProperty(exports, "initAndBind", {
  enumerable: true,
  get: function () {
    return _sdk.initAndBind;
  }
});
Object.defineProperty(exports, "instrumentFetchRequest", {
  enumerable: true,
  get: function () {
    return _fetch.instrumentFetchRequest;
  }
});
Object.defineProperty(exports, "isAbsolute", {
  enumerable: true,
  get: function () {
    return _path.isAbsolute;
  }
});
Object.defineProperty(exports, "isBrowser", {
  enumerable: true,
  get: function () {
    return _isBrowser.isBrowser;
  }
});
Object.defineProperty(exports, "isBrowserBundle", {
  enumerable: true,
  get: function () {
    return _env.isBrowserBundle;
  }
});
Object.defineProperty(exports, "isDOMError", {
  enumerable: true,
  get: function () {
    return _is.isDOMError;
  }
});
Object.defineProperty(exports, "isDOMException", {
  enumerable: true,
  get: function () {
    return _is.isDOMException;
  }
});
Object.defineProperty(exports, "isElement", {
  enumerable: true,
  get: function () {
    return _is.isElement;
  }
});
Object.defineProperty(exports, "isEnabled", {
  enumerable: true,
  get: function () {
    return _exports.isEnabled;
  }
});
Object.defineProperty(exports, "isError", {
  enumerable: true,
  get: function () {
    return _is.isError;
  }
});
Object.defineProperty(exports, "isErrorEvent", {
  enumerable: true,
  get: function () {
    return _is.isErrorEvent;
  }
});
Object.defineProperty(exports, "isEvent", {
  enumerable: true,
  get: function () {
    return _is.isEvent;
  }
});
Object.defineProperty(exports, "isInitialized", {
  enumerable: true,
  get: function () {
    return _exports.isInitialized;
  }
});
Object.defineProperty(exports, "isInstanceOf", {
  enumerable: true,
  get: function () {
    return _is.isInstanceOf;
  }
});
Object.defineProperty(exports, "isMatchingPattern", {
  enumerable: true,
  get: function () {
    return _string.isMatchingPattern;
  }
});
Object.defineProperty(exports, "isNativeFunction", {
  enumerable: true,
  get: function () {
    return _supports.isNativeFunction;
  }
});
Object.defineProperty(exports, "isNodeEnv", {
  enumerable: true,
  get: function () {
    return _node.isNodeEnv;
  }
});
Object.defineProperty(exports, "isParameterizedString", {
  enumerable: true,
  get: function () {
    return _is.isParameterizedString;
  }
});
Object.defineProperty(exports, "isPlainObject", {
  enumerable: true,
  get: function () {
    return _is.isPlainObject;
  }
});
Object.defineProperty(exports, "isPrimitive", {
  enumerable: true,
  get: function () {
    return _is.isPrimitive;
  }
});
Object.defineProperty(exports, "isRateLimited", {
  enumerable: true,
  get: function () {
    return _ratelimit.isRateLimited;
  }
});
Object.defineProperty(exports, "isRegExp", {
  enumerable: true,
  get: function () {
    return _is.isRegExp;
  }
});
Object.defineProperty(exports, "isSentryRequestUrl", {
  enumerable: true,
  get: function () {
    return _isSentryRequestUrl.isSentryRequestUrl;
  }
});
Object.defineProperty(exports, "isString", {
  enumerable: true,
  get: function () {
    return _is.isString;
  }
});
Object.defineProperty(exports, "isSyntheticEvent", {
  enumerable: true,
  get: function () {
    return _is.isSyntheticEvent;
  }
});
Object.defineProperty(exports, "isThenable", {
  enumerable: true,
  get: function () {
    return _is.isThenable;
  }
});
Object.defineProperty(exports, "isVueViewModel", {
  enumerable: true,
  get: function () {
    return _is.isVueViewModel;
  }
});
Object.defineProperty(exports, "join", {
  enumerable: true,
  get: function () {
    return _path.join;
  }
});
Object.defineProperty(exports, "lastEventId", {
  enumerable: true,
  get: function () {
    return _exports.lastEventId;
  }
});
Object.defineProperty(exports, "linkedErrorsIntegration", {
  enumerable: true,
  get: function () {
    return _linkederrors.linkedErrorsIntegration;
  }
});
Object.defineProperty(exports, "loadModule", {
  enumerable: true,
  get: function () {
    return _node.loadModule;
  }
});
Object.defineProperty(exports, "logSpanEnd", {
  enumerable: true,
  get: function () {
    return _logSpans.logSpanEnd;
  }
});
Object.defineProperty(exports, "logSpanStart", {
  enumerable: true,
  get: function () {
    return _logSpans.logSpanStart;
  }
});
Object.defineProperty(exports, "logger", {
  enumerable: true,
  get: function () {
    return _logger.logger;
  }
});
Object.defineProperty(exports, "makeDsn", {
  enumerable: true,
  get: function () {
    return _dsn.makeDsn;
  }
});
Object.defineProperty(exports, "makeFifoCache", {
  enumerable: true,
  get: function () {
    return _cache.makeFifoCache;
  }
});
Object.defineProperty(exports, "makeMultiplexedTransport", {
  enumerable: true,
  get: function () {
    return _multiplexed.makeMultiplexedTransport;
  }
});
Object.defineProperty(exports, "makeOfflineTransport", {
  enumerable: true,
  get: function () {
    return _offline.makeOfflineTransport;
  }
});
Object.defineProperty(exports, "makePromiseBuffer", {
  enumerable: true,
  get: function () {
    return _promisebuffer.makePromiseBuffer;
  }
});
Object.defineProperty(exports, "makeSession", {
  enumerable: true,
  get: function () {
    return _session.makeSession;
  }
});
Object.defineProperty(exports, "markFunctionWrapped", {
  enumerable: true,
  get: function () {
    return _object.markFunctionWrapped;
  }
});
Object.defineProperty(exports, "maybeInstrument", {
  enumerable: true,
  get: function () {
    return _handlers.maybeInstrument;
  }
});
Object.defineProperty(exports, "memoBuilder", {
  enumerable: true,
  get: function () {
    return _memo.memoBuilder;
  }
});
Object.defineProperty(exports, "mergeScopeData", {
  enumerable: true,
  get: function () {
    return _applyScopeDataToEvent.mergeScopeData;
  }
});
Object.defineProperty(exports, "metrics", {
  enumerable: true,
  get: function () {
    return _exports2.metrics;
  }
});
Object.defineProperty(exports, "metricsDefault", {
  enumerable: true,
  get: function () {
    return _exportsDefault.metricsDefault;
  }
});
Object.defineProperty(exports, "moduleMetadataIntegration", {
  enumerable: true,
  get: function () {
    return _metadata.moduleMetadataIntegration;
  }
});
Object.defineProperty(exports, "node", {
  enumerable: true,
  get: function () {
    return _nodeStackTrace.node;
  }
});
Object.defineProperty(exports, "nodeStackLineParser", {
  enumerable: true,
  get: function () {
    return _nodeStackTrace.nodeStackLineParser;
  }
});
Object.defineProperty(exports, "normalize", {
  enumerable: true,
  get: function () {
    return _normalize.normalize;
  }
});
Object.defineProperty(exports, "normalizePath", {
  enumerable: true,
  get: function () {
    return _path.normalizePath;
  }
});
Object.defineProperty(exports, "normalizeToSize", {
  enumerable: true,
  get: function () {
    return _normalize.normalizeToSize;
  }
});
Object.defineProperty(exports, "normalizeUrlToBase", {
  enumerable: true,
  get: function () {
    return _normalize.normalizeUrlToBase;
  }
});
Object.defineProperty(exports, "notifyEventProcessors", {
  enumerable: true,
  get: function () {
    return _eventProcessors.notifyEventProcessors;
  }
});
Object.defineProperty(exports, "objectify", {
  enumerable: true,
  get: function () {
    return _object.objectify;
  }
});
Object.defineProperty(exports, "originalConsoleMethods", {
  enumerable: true,
  get: function () {
    return _logger.originalConsoleMethods;
  }
});
Object.defineProperty(exports, "parameterize", {
  enumerable: true,
  get: function () {
    return _parameterize.parameterize;
  }
});
Object.defineProperty(exports, "parseBaggageHeader", {
  enumerable: true,
  get: function () {
    return _baggage.parseBaggageHeader;
  }
});
Object.defineProperty(exports, "parseEnvelope", {
  enumerable: true,
  get: function () {
    return _envelope2.parseEnvelope;
  }
});
Object.defineProperty(exports, "parseRetryAfterHeader", {
  enumerable: true,
  get: function () {
    return _ratelimit.parseRetryAfterHeader;
  }
});
Object.defineProperty(exports, "parseSampleRate", {
  enumerable: true,
  get: function () {
    return _parseSampleRate.parseSampleRate;
  }
});
Object.defineProperty(exports, "parseSemver", {
  enumerable: true,
  get: function () {
    return _misc.parseSemver;
  }
});
Object.defineProperty(exports, "parseStackFrames", {
  enumerable: true,
  get: function () {
    return _eventbuilder.parseStackFrames;
  }
});
Object.defineProperty(exports, "parseUrl", {
  enumerable: true,
  get: function () {
    return _url.parseUrl;
  }
});
Object.defineProperty(exports, "prepareEvent", {
  enumerable: true,
  get: function () {
    return _prepareEvent.prepareEvent;
  }
});
Object.defineProperty(exports, "profiler", {
  enumerable: true,
  get: function () {
    return _profiling.profiler;
  }
});
Object.defineProperty(exports, "propagationContextFromHeaders", {
  enumerable: true,
  get: function () {
    return _tracing.propagationContextFromHeaders;
  }
});
Object.defineProperty(exports, "registerSpanErrorInstrumentation", {
  enumerable: true,
  get: function () {
    return _errors.registerSpanErrorInstrumentation;
  }
});
Object.defineProperty(exports, "rejectedSyncPromise", {
  enumerable: true,
  get: function () {
    return _syncpromise.rejectedSyncPromise;
  }
});
Object.defineProperty(exports, "relative", {
  enumerable: true,
  get: function () {
    return _path.relative;
  }
});
Object.defineProperty(exports, "requestDataIntegration", {
  enumerable: true,
  get: function () {
    return _requestdata.requestDataIntegration;
  }
});
Object.defineProperty(exports, "resetInstrumentationHandlers", {
  enumerable: true,
  get: function () {
    return _handlers.resetInstrumentationHandlers;
  }
});
Object.defineProperty(exports, "resolve", {
  enumerable: true,
  get: function () {
    return _path.resolve;
  }
});
Object.defineProperty(exports, "resolvedSyncPromise", {
  enumerable: true,
  get: function () {
    return _syncpromise.resolvedSyncPromise;
  }
});
Object.defineProperty(exports, "rewriteFramesIntegration", {
  enumerable: true,
  get: function () {
    return _rewriteframes.rewriteFramesIntegration;
  }
});
Object.defineProperty(exports, "safeJoin", {
  enumerable: true,
  get: function () {
    return _string.safeJoin;
  }
});
Object.defineProperty(exports, "sampleSpan", {
  enumerable: true,
  get: function () {
    return _sampling.sampleSpan;
  }
});
Object.defineProperty(exports, "serializeEnvelope", {
  enumerable: true,
  get: function () {
    return _envelope2.serializeEnvelope;
  }
});
Object.defineProperty(exports, "sessionTimingIntegration", {
  enumerable: true,
  get: function () {
    return _sessiontiming.sessionTimingIntegration;
  }
});
Object.defineProperty(exports, "setAsyncContextStrategy", {
  enumerable: true,
  get: function () {
    return _index.setAsyncContextStrategy;
  }
});
Object.defineProperty(exports, "setCapturedScopesOnSpan", {
  enumerable: true,
  get: function () {
    return _utils.setCapturedScopesOnSpan;
  }
});
Object.defineProperty(exports, "setContext", {
  enumerable: true,
  get: function () {
    return _exports.setContext;
  }
});
Object.defineProperty(exports, "setCurrentClient", {
  enumerable: true,
  get: function () {
    return _sdk.setCurrentClient;
  }
});
Object.defineProperty(exports, "setExtra", {
  enumerable: true,
  get: function () {
    return _exports.setExtra;
  }
});
Object.defineProperty(exports, "setExtras", {
  enumerable: true,
  get: function () {
    return _exports.setExtras;
  }
});
Object.defineProperty(exports, "setHttpStatus", {
  enumerable: true,
  get: function () {
    return _spanstatus.setHttpStatus;
  }
});
Object.defineProperty(exports, "setMeasurement", {
  enumerable: true,
  get: function () {
    return _measurement.setMeasurement;
  }
});
Object.defineProperty(exports, "setTag", {
  enumerable: true,
  get: function () {
    return _exports.setTag;
  }
});
Object.defineProperty(exports, "setTags", {
  enumerable: true,
  get: function () {
    return _exports.setTags;
  }
});
Object.defineProperty(exports, "setUser", {
  enumerable: true,
  get: function () {
    return _exports.setUser;
  }
});
Object.defineProperty(exports, "severityLevelFromString", {
  enumerable: true,
  get: function () {
    return _severity.severityLevelFromString;
  }
});
Object.defineProperty(exports, "snipLine", {
  enumerable: true,
  get: function () {
    return _string.snipLine;
  }
});
Object.defineProperty(exports, "spanIsSampled", {
  enumerable: true,
  get: function () {
    return _spanUtils.spanIsSampled;
  }
});
Object.defineProperty(exports, "spanTimeInputToSeconds", {
  enumerable: true,
  get: function () {
    return _spanUtils.spanTimeInputToSeconds;
  }
});
Object.defineProperty(exports, "spanToBaggageHeader", {
  enumerable: true,
  get: function () {
    return _dynamicSamplingContext.spanToBaggageHeader;
  }
});
Object.defineProperty(exports, "spanToJSON", {
  enumerable: true,
  get: function () {
    return _spanUtils.spanToJSON;
  }
});
Object.defineProperty(exports, "spanToTraceContext", {
  enumerable: true,
  get: function () {
    return _spanUtils.spanToTraceContext;
  }
});
Object.defineProperty(exports, "spanToTraceHeader", {
  enumerable: true,
  get: function () {
    return _spanUtils.spanToTraceHeader;
  }
});
Object.defineProperty(exports, "stackParserFromStackParserOptions", {
  enumerable: true,
  get: function () {
    return _stacktrace.stackParserFromStackParserOptions;
  }
});
Object.defineProperty(exports, "startIdleSpan", {
  enumerable: true,
  get: function () {
    return _idleSpan.startIdleSpan;
  }
});
Object.defineProperty(exports, "startInactiveSpan", {
  enumerable: true,
  get: function () {
    return _trace.startInactiveSpan;
  }
});
Object.defineProperty(exports, "startNewTrace", {
  enumerable: true,
  get: function () {
    return _trace.startNewTrace;
  }
});
Object.defineProperty(exports, "startSession", {
  enumerable: true,
  get: function () {
    return _exports.startSession;
  }
});
Object.defineProperty(exports, "startSpan", {
  enumerable: true,
  get: function () {
    return _trace.startSpan;
  }
});
Object.defineProperty(exports, "startSpanManual", {
  enumerable: true,
  get: function () {
    return _trace.startSpanManual;
  }
});
Object.defineProperty(exports, "stringMatchesSomePattern", {
  enumerable: true,
  get: function () {
    return _string.stringMatchesSomePattern;
  }
});
Object.defineProperty(exports, "stripSentryFramesAndReverse", {
  enumerable: true,
  get: function () {
    return _stacktrace.stripSentryFramesAndReverse;
  }
});
Object.defineProperty(exports, "stripUrlQueryAndFragment", {
  enumerable: true,
  get: function () {
    return _url.stripUrlQueryAndFragment;
  }
});
Object.defineProperty(exports, "supportsDOMError", {
  enumerable: true,
  get: function () {
    return _supports.supportsDOMError;
  }
});
Object.defineProperty(exports, "supportsDOMException", {
  enumerable: true,
  get: function () {
    return _supports.supportsDOMException;
  }
});
Object.defineProperty(exports, "supportsErrorEvent", {
  enumerable: true,
  get: function () {
    return _supports.supportsErrorEvent;
  }
});
Object.defineProperty(exports, "supportsFetch", {
  enumerable: true,
  get: function () {
    return _supports.supportsFetch;
  }
});
Object.defineProperty(exports, "supportsHistory", {
  enumerable: true,
  get: function () {
    return _supportsHistory.supportsHistory;
  }
});
Object.defineProperty(exports, "supportsNativeFetch", {
  enumerable: true,
  get: function () {
    return _supports.supportsNativeFetch;
  }
});
Object.defineProperty(exports, "supportsReferrerPolicy", {
  enumerable: true,
  get: function () {
    return _supports.supportsReferrerPolicy;
  }
});
Object.defineProperty(exports, "supportsReportingObserver", {
  enumerable: true,
  get: function () {
    return _supports.supportsReportingObserver;
  }
});
Object.defineProperty(exports, "suppressTracing", {
  enumerable: true,
  get: function () {
    return _trace.suppressTracing;
  }
});
Object.defineProperty(exports, "thirdPartyErrorFilterIntegration", {
  enumerable: true,
  get: function () {
    return _thirdPartyErrorsFilter.thirdPartyErrorFilterIntegration;
  }
});
Object.defineProperty(exports, "timedEventsToMeasurements", {
  enumerable: true,
  get: function () {
    return _measurement.timedEventsToMeasurements;
  }
});
Object.defineProperty(exports, "timestampInSeconds", {
  enumerable: true,
  get: function () {
    return _time.timestampInSeconds;
  }
});
Object.defineProperty(exports, "triggerHandlers", {
  enumerable: true,
  get: function () {
    return _handlers.triggerHandlers;
  }
});
Object.defineProperty(exports, "trpcMiddleware", {
  enumerable: true,
  get: function () {
    return _trpc.trpcMiddleware;
  }
});
Object.defineProperty(exports, "truncate", {
  enumerable: true,
  get: function () {
    return _string.truncate;
  }
});
Object.defineProperty(exports, "updateRateLimits", {
  enumerable: true,
  get: function () {
    return _ratelimit.updateRateLimits;
  }
});
Object.defineProperty(exports, "updateSession", {
  enumerable: true,
  get: function () {
    return _session.updateSession;
  }
});
Object.defineProperty(exports, "updateSpanName", {
  enumerable: true,
  get: function () {
    return _spanUtils.updateSpanName;
  }
});
Object.defineProperty(exports, "urlEncode", {
  enumerable: true,
  get: function () {
    return _object.urlEncode;
  }
});
Object.defineProperty(exports, "uuid4", {
  enumerable: true,
  get: function () {
    return _misc.uuid4;
  }
});
Object.defineProperty(exports, "validSeverityLevels", {
  enumerable: true,
  get: function () {
    return _severity.validSeverityLevels;
  }
});
Object.defineProperty(exports, "vercelWaitUntil", {
  enumerable: true,
  get: function () {
    return _vercelWaitUntil.vercelWaitUntil;
  }
});
Object.defineProperty(exports, "watchdogTimer", {
  enumerable: true,
  get: function () {
    return _anr.watchdogTimer;
  }
});
Object.defineProperty(exports, "winterCGHeadersToDict", {
  enumerable: true,
  get: function () {
    return _requestdata2.winterCGHeadersToDict;
  }
});
Object.defineProperty(exports, "winterCGRequestToRequestData", {
  enumerable: true,
  get: function () {
    return _requestdata2.winterCGRequestToRequestData;
  }
});
Object.defineProperty(exports, "withActiveSpan", {
  enumerable: true,
  get: function () {
    return _trace.withActiveSpan;
  }
});
Object.defineProperty(exports, "withIsolationScope", {
  enumerable: true,
  get: function () {
    return _currentScopes.withIsolationScope;
  }
});
Object.defineProperty(exports, "withMonitor", {
  enumerable: true,
  get: function () {
    return _exports.withMonitor;
  }
});
Object.defineProperty(exports, "withScope", {
  enumerable: true,
  get: function () {
    return _currentScopes.withScope;
  }
});
Object.defineProperty(exports, "zodErrorsIntegration", {
  enumerable: true,
  get: function () {
    return _zoderrors.zodErrorsIntegration;
  }
});

var _errors = require("./tracing/errors.js");

var _utils = require("./tracing/utils.js");

var _hubextensions = require("./tracing/hubextensions.js");

var _idleSpan = require("./tracing/idleSpan.js");

var _sentrySpan = require("./tracing/sentrySpan.js");

var _sentryNonRecordingSpan = require("./tracing/sentryNonRecordingSpan.js");

var _spanstatus = require("./tracing/spanstatus.js");

var _trace = require("./tracing/trace.js");

var _dynamicSamplingContext = require("./tracing/dynamicSamplingContext.js");

var _measurement = require("./tracing/measurement.js");

var _sampling = require("./tracing/sampling.js");

var _logSpans = require("./tracing/logSpans.js");

var _semanticAttributes = require("./semanticAttributes.js");

var _envelope = require("./envelope.js");

var _exports = require("./exports.js");

var _currentScopes = require("./currentScopes.js");

var _defaultScopes = require("./defaultScopes.js");

var _index = require("./asyncContext/index.js");

var _carrier = require("./carrier.js");

var _session = require("./session.js");

var _sessionflusher = require("./sessionflusher.js");

var _scope = require("./scope.js");

var _eventProcessors = require("./eventProcessors.js");

var _api = require("./api.js");

var _baseclient = require("./baseclient.js");

var _serverRuntimeClient = require("./server-runtime-client.js");

var _sdk = require("./sdk.js");

var _base = require("./transports/base.js");

var _offline = require("./transports/offline.js");

var _multiplexed = require("./transports/multiplexed.js");

var _integration = require("./integration.js");

var _applyScopeDataToEvent = require("./utils/applyScopeDataToEvent.js");

var _prepareEvent = require("./utils/prepareEvent.js");

var _checkin = require("./checkin.js");

var _hasTracingEnabled = require("./utils/hasTracingEnabled.js");

var _isSentryRequestUrl = require("./utils/isSentryRequestUrl.js");

var _handleCallbackErrors = require("./utils/handleCallbackErrors.js");

var _parameterize = require("./utils/parameterize.js");

var _spanUtils = require("./utils/spanUtils.js");

var _parseSampleRate = require("./utils/parseSampleRate.js");

var _sdkMetadata = require("./utils/sdkMetadata.js");

var _traceData = require("./utils/traceData.js");

var _meta = require("./utils/meta.js");

var _constants = require("./constants.js");

var _breadcrumbs = require("./breadcrumbs.js");

var _functiontostring = require("./integrations/functiontostring.js");

var _inboundfilters = require("./integrations/inboundfilters.js");

var _linkederrors = require("./integrations/linkederrors.js");

var _metadata = require("./integrations/metadata.js");

var _requestdata = require("./integrations/requestdata.js");

var _captureconsole = require("./integrations/captureconsole.js");

var _debug = require("./integrations/debug.js");

var _dedupe = require("./integrations/dedupe.js");

var _extraerrordata = require("./integrations/extraerrordata.js");

var _rewriteframes = require("./integrations/rewriteframes.js");

var _sessiontiming = require("./integrations/sessiontiming.js");

var _zoderrors = require("./integrations/zoderrors.js");

var _thirdPartyErrorsFilter = require("./integrations/third-party-errors-filter.js");

var _exports2 = require("./metrics/exports.js");

var _profiling = require("./profiling.js");

var _exportsDefault = require("./metrics/exports-default.js");

var _browserAggregator = require("./metrics/browser-aggregator.js");

var _metricSummary = require("./metrics/metric-summary.js");

var _fetch = require("./fetch.js");

var _trpc = require("./trpc.js");

var _feedback = require("./feedback.js");

var _getCurrentHubShim = require("./getCurrentHubShim.js");

var _aggregateErrors = require("./utils-hoist/aggregate-errors.js");

var _array = require("./utils-hoist/array.js");

var _breadcrumbLogLevel = require("./utils-hoist/breadcrumb-log-level.js");

var _browser = require("./utils-hoist/browser.js");

var _dsn = require("./utils-hoist/dsn.js");

var _error = require("./utils-hoist/error.js");

var _worldwide = require("./utils-hoist/worldwide.js");

var _console = require("./utils-hoist/instrument/console.js");

var _fetch2 = require("./utils-hoist/instrument/fetch.js");

var _globalError = require("./utils-hoist/instrument/globalError.js");

var _globalUnhandledRejection = require("./utils-hoist/instrument/globalUnhandledRejection.js");

var _handlers = require("./utils-hoist/instrument/handlers.js");

var _is = require("./utils-hoist/is.js");

var _isBrowser = require("./utils-hoist/isBrowser.js");

var _logger = require("./utils-hoist/logger.js");

var _memo = require("./utils-hoist/memo.js");

var _misc = require("./utils-hoist/misc.js");

var _node = require("./utils-hoist/node.js");

var _normalize = require("./utils-hoist/normalize.js");

var _object = require("./utils-hoist/object.js");

var _path = require("./utils-hoist/path.js");

var _promisebuffer = require("./utils-hoist/promisebuffer.js");

var _requestdata2 = require("./utils-hoist/requestdata.js");

var _severity = require("./utils-hoist/severity.js");

var _stacktrace = require("./utils-hoist/stacktrace.js");

var _nodeStackTrace = require("./utils-hoist/node-stack-trace.js");

var _string = require("./utils-hoist/string.js");

var _supports = require("./utils-hoist/supports.js");

var _syncpromise = require("./utils-hoist/syncpromise.js");

var _time = require("./utils-hoist/time.js");

var _tracing = require("./utils-hoist/tracing.js");

var _env = require("./utils-hoist/env.js");

var _envelope2 = require("./utils-hoist/envelope.js");

var _clientreport = require("./utils-hoist/clientreport.js");

var _ratelimit = require("./utils-hoist/ratelimit.js");

var _baggage = require("./utils-hoist/baggage.js");

var _url = require("./utils-hoist/url.js");

var _cache = require("./utils-hoist/cache.js");

var _eventbuilder = require("./utils-hoist/eventbuilder.js");

var _anr = require("./utils-hoist/anr.js");

var _lru = require("./utils-hoist/lru.js");

var _propagationContext = require("./utils-hoist/propagationContext.js");

var _vercelWaitUntil = require("./utils-hoist/vercelWaitUntil.js");

var _version = require("./utils-hoist/version.js");

var _debugIds = require("./utils-hoist/debug-ids.js");

var _escapeStringForRegex = require("./utils-hoist/vendor/escapeStringForRegex.js");

var _supportsHistory = require("./utils-hoist/vendor/supportsHistory.js");

var _asyncNullishCoalesce = require("./utils-hoist/buildPolyfills/_asyncNullishCoalesce.js");

var _asyncOptionalChain = require("./utils-hoist/buildPolyfills/_asyncOptionalChain.js");

var _asyncOptionalChainDelete = require("./utils-hoist/buildPolyfills/_asyncOptionalChainDelete.js");

var _nullishCoalesce = require("./utils-hoist/buildPolyfills/_nullishCoalesce.js");

var _optionalChain = require("./utils-hoist/buildPolyfills/_optionalChain.js");

var _optionalChainDelete = require("./utils-hoist/buildPolyfills/_optionalChainDelete.js");